export default "__VITE_ASSET__b2NAfvZ$__"